import { Phone, Mail, MapPin, PhoneCall, ArrowRight, CalendarCheck } from "lucide-react";
import { FadeIn } from "@/components/Reveal";
import { SITE } from "@/config/site";

const SKYLINE_IMAGE =
  "https://images.unsplash.com/photo-1578009661061-f2ef694ebedb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxjbGV2ZWxhbmQlMjBza3lsaW5lJTIwY2l0eXxlbnwwfHx8fDE3OTA2MjU1NTN8MA&ixlib=rb-4.1.0&q=85";

export const Contact = () => (
  <section id="contact" className="bg-white py-24 lg:py-32">
    <div className="container-tsm grid items-center gap-14 lg:grid-cols-12 lg:gap-10">
      <FadeIn className="lg:col-span-6">
        <p className="eyebrow">Contact</p>
        <h2
          className="mt-6 font-serif text-4xl font-semibold leading-[1.08] tracking-tight text-navy sm:text-5xl lg:text-6xl"
          data-testid="contact-headline"
        >
          Talk With <span className="italic text-gold">TSM</span>
        </h2>

        <dl className="mt-10 space-y-7" data-testid="contact-details">
          <div className="flex items-start gap-4">
            <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border border-gold/40 text-gold">
              <Phone className="h-4 w-4" />
            </span>
            <div>
              <dt className="font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-navy/50">Phone</dt>
              <dd className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-phone">{SITE.phone}</dd>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border border-gold/40 text-gold">
              <Mail className="h-4 w-4" />
            </span>
            <div>
              <dt className="font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-navy/50">Email</dt>
              <dd className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-email">{SITE.email}</dd>
            </div>
          </div>
          <div className="flex items-start gap-4">
            <span className="mt-1 flex h-10 w-10 shrink-0 items-center justify-center rounded-sm border border-gold/40 text-gold">
              <MapPin className="h-4 w-4" />
            </span>
            <div>
              <dt className="font-mono text-[11px] font-semibold uppercase tracking-[0.16em] text-navy/50">Service Area</dt>
              <dd className="mt-1 font-serif text-2xl font-semibold text-navy" data-testid="contact-service-area">{SITE.serviceArea}</dd>
            </div>
          </div>
        </dl>

        <p className="mt-8 max-w-md text-sm italic leading-relaxed text-ink/55" data-testid="contact-mobile-note">
          Mobile services may be available depending on service type and location.
        </p>

        <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
          <a href={SITE.phoneHref} data-testid="contact-cta-call" className="btn-gold">
            <PhoneCall className="h-4 w-4" />
            Call TSM Group CLE
          </a>
          <a href="#request" data-testid="contact-cta-request" className="btn-outline">
            Request a Service
            <ArrowRight className="h-4 w-4" />
          </a>
          <a href={SITE.schedulingUrl} data-testid="contact-cta-schedule" className="btn-outline">
            <CalendarCheck className="h-4 w-4" />
            Schedule a Consultation
          </a>
        </div>
        <p className="mt-5 text-xs text-ink/45" data-testid="contact-consultation-note">
          Consultations are available for business compliance and operational discussions.
        </p>
      </FadeIn>

      <FadeIn delay={0.15} className="lg:col-span-6">
        <div className="relative">
          <div className="absolute -bottom-4 -right-4 hidden h-full w-full rounded-lg border border-gold/50 sm:block" aria-hidden="true" />
          <img
            src={SKYLINE_IMAGE}
            alt="Downtown Cleveland, Ohio skyline representing the TSM Group CLE service area"
            className="relative h-80 w-full rounded-lg object-cover shadow-[0_8px_30px_rgb(0,0,0,0.1)] lg:h-[460px]"
            data-testid="contact-image"
          />
          <div className="absolute left-5 top-5 rounded-sm bg-navy/90 px-4 py-2.5 backdrop-blur-sm">
            <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-gold">
              Serving Northeast Ohio
            </p>
          </div>
        </div>
      </FadeIn>
    </div>
  </section>
);
